import { WEB_URL } from '../constant'

let token = window.localStorage.getItem('instalinkToken')
let apiUrl = process.env.REACT_APP_INSTALINK_API_URL
let tokenExpiry

if (process.env.NODE_ENV === 'production') {
  apiUrl = WEB_URL + '/api'
}

export const INSTALINK_API_URL = apiUrl

function getAuthorization () {
  const authValue = `Bearer ${token}`
  return authValue
}

function getHeaders () {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: getAuthorization()
  }
}

function getUrl (url) {
  if (url.startsWith('/')) {
    return INSTALINK_API_URL + url
  }
  return url
}

function get (url, { customHandleResponse } = {}) {
  const options = {
    method: 'GET',
    headers: getHeaders()
  }
  return fetch(getUrl(url), options).then(response =>
    customHandleResponse
      ? customHandleResponse(response, options)
      : handleResponse(response)
  )
}

function post (url, body, { customHandleResponse } = {}) {
  const options = {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(body)
  }
  return fetch(getUrl(url), options).then(response =>
    customHandleResponse
      ? customHandleResponse(response, options)
      : handleResponse(response)
  )
}

function put (url, body, { customHandleResponse } = {}) {
  const options = {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(body)
  }
  return fetch(getUrl(url), options).then(response =>
    customHandleResponse
      ? customHandleResponse(response, options)
      : handleResponse(response)
  )
}

function patch (url, body, { customHandleResponse } = {}) {
  const options = {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify(body)
  }
  return fetch(getUrl(url), options).then(response =>
    customHandleResponse
      ? customHandleResponse(response, options)
      : handleResponse(response)
  )
}

function _delete (url, { customHandleResponse } = {}) {
  const options = {
    method: 'DELETE',
    headers: getHeaders()
  }
  return fetch(getUrl(url), options).then(response =>
    customHandleResponse
      ? customHandleResponse(response, options)
      : handleResponse(response)
  )
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok && data.error) {
      return Promise.reject(data.error)
    }
    if (!response.ok) {
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}

function updateTokenExpiry () {
  if (token) {
    const [, payload] = token.split('.')
    const decodedPayload = JSON.parse(atob(payload))
    tokenExpiry = decodedPayload.exp * 1000
  } else {
    tokenExpiry = null
  }
  return tokenExpiry
}

function setToken (newToken, refreshToken) {
  token = newToken
  window.localStorage.setItem('instalinkToken', newToken)
  updateTokenExpiry()
}

function setRefreshToken (refreshToken) {
  window.localStorage.setItem('instalinkRefreshToken', refreshToken)
}

const ApiClient = {
  get,
  post,
  put,
  patch,
  delete: _delete,
  setToken,
  setRefreshToken,
  get shouldRenewToken () {
    if (!token || token === 'null' || token === 'undefined') {
      return true
    }
    tokenExpiry ??= updateTokenExpiry()
    const now = Date.now()
    if (!tokenExpiry) {
      return true
    }
    const offset = 60 * 1000
    if (tokenExpiry - offset < now) {
      // Should renew token before token expired
      return true
    }
    return false
  },
  get hasToken () {
    if (!token || token === 'null' || token === 'undefined') {
      return false
    }
    tokenExpiry ??= updateTokenExpiry()
    const now = Date.now()
    if (tokenExpiry && tokenExpiry < now) {
      return false
    }
    return true
  },
  get token () { return token },
  get refreshToken () {
    return window.localStorage.getItem('instalinkRefreshToken')
  }
}

export default ApiClient
